// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
ion-content {
  --background: linear-gradient(135deg, #9ba5ff 0%, #4846b8 50%, #0c2061 100%);
  position: relative;
  overflow: hidden;
  min-height: 100vh;
}

ion-content::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: radial-gradient(circle at 20% 80%, rgba(255, 255, 255, 0.2) 0%, transparent 15%), radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.2) 0%, transparent 15%), radial-gradient(circle at 40% 40%, rgba(255, 255, 255, 0.2) 0%, transparent 15%), radial-gradient(circle at 60% 60%, rgba(255, 255, 255, 0.2) 0%, transparent 15%), radial-gradient(circle at 30% 70%, rgba(255, 255, 255, 0.2) 0%, transparent 15%), radial-gradient(circle at 70% 30%, rgba(255, 255, 255, 0.2) 0%, transparent 15%), radial-gradient(circle at 10% 50%, rgba(255, 255, 255, 0.2) 0%, transparent 15%), radial-gradient(circle at 90% 50%, rgba(255, 255, 255, 0.2) 0%, transparent 15%);
  animation: float 15s ease-in-out infinite;
  z-index: 1;
  pointer-events: none;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0) translateX(0);
  }
  25% {
    transform: translateY(-10px) translateX(5px);
  }
  50% {
    transform: translateY(0) translateX(10px);
  }
  75% {
    transform: translateY(10px) translateX(5px);
  }
}
/* Container principal avec glassmorphism */
ion-grid {
  position: relative;
  z-index: 1;
  max-width: 400px;
  margin: 0 auto;
  padding: 2rem;
  margin-top: 8rem;
}

/* Carte glassmorphism pour le formulaire */
form {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 8px 32px rgba(31, 38, 135, 0.37);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

form::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
  transition: left 0.5s;
}

form:hover::before {
  left: 100%;
}

form:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 40px rgba(31, 38, 135, 0.5);
}

/* Styling des champs de saisie */
ion-item {
  --background: rgba(255, 255, 255, 0.9);
  --border-radius: 12px;
  --inner-padding-start: 16px;
  --inner-padding-end: 16px;
  --padding-start: 0;
  --padding-end: 0;
  margin-bottom: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid transparent;
}

ion-item:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

ion-item.item-has-focus {
  --background: rgba(255, 255, 255, 0.95);
  border-color: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  background-clip: padding-box;
}

/* Labels flottants améliorés */
ion-label {
  --color: #636e72;
  font-weight: 500;
  font-size: 0.9rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

ion-item.item-has-focus ion-label {
  --color: #667eea;
  font-weight: 600;
}

/* Champs de saisie */
ion-input {
  --color: #2d3436;
  --placeholder-color: #636e72;
  font-size: 1rem;
  font-weight: 500;
}

/* Bouton de connexion moderne */
.btn {
  width: 100%;
  height: 3.5rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: none;
  margin: 1.5rem auto 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
  position: relative;
  overflow: hidden;
}

.btn::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.6);
}

.btn:hover::before {
  left: 100%;
}

.btn:active {
  transform: translateY(0);
}

.buttons-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/forgot-password/forgot-password.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,4EAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAEJ;;AACE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gqBACE;EAQF,yCAAA;EACA,UAAA;EACA,oBAAA;AANJ;;AASE;EACE;IACE,sCAAA;EANJ;EAQE;IACE,4CAAA;EANJ;EAQE;IACE,yCAAA;EANJ;EAQE;IACE,2CAAA;EANJ;AACF;AAUI,2CAAA;AACA;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;AARR;;AAWM,2CAAA;AACA;EACE,oCAAA;EACA,2BAAA;EACA,mCAAA;EACA,0CAAA;EACA,mBAAA;EACA,aAAA;EACA,8CAAA;EACA,iDAAA;EACA,kBAAA;EACA,gBAAA;AARR;;AAWM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,sFAAA;EACA,qBAAA;AARR;;AAWM;EACE,UAAA;AARR;;AAWM;EACE,2BAAA;EACA,8CAAA;AARR;;AAWM,iCAAA;AACA;EACE,sCAAA;EACA,qBAAA;EACA,2BAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,yCAAA;EACA,iDAAA;EACA,6BAAA;AARR;;AAWM;EACE,2BAAA;EACA,0CAAA;AARR;;AAWM;EACE,uCAAA;EACA,+DAAA;EACA,6DAAA;EACA,4BAAA;AARR;;AAWM,+BAAA;AACA;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iDAAA;AARR;;AAWM;EACE,gBAAA;EACA,gBAAA;AARR;;AAWM,qBAAA;AACA;EACE,gBAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;AARR;;AAWM,gCAAA;AACA;EACE,WAAA;EACA,cAAA;EACA,6DAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,oBAAA;EACA,wBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iDAAA;EACA,+CAAA;EACA,kBAAA;EACA,gBAAA;AARR;;AAWM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,sFAAA;EACA,qBAAA;AARR;;AAWM;EACE,2BAAA;EACA,+CAAA;AARR;;AAWM;EACE,UAAA;AARR;;AAWM;EACE,wBAAA;AARR;;AAWM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AARR","sourcesContent":["ion-content {\r\n    --background: linear-gradient(135deg, #9ba5ff 0%, #4846b8 50%, #0c2061 100%);\r\n    position: relative;\r\n    overflow: hidden;\r\n    min-height: 100vh;\r\n  }\r\n\r\n  ion-content::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-image: \r\n      radial-gradient(circle at 20% 80%, rgba(255, 255, 255, 0.2) 0%, transparent 15%),\r\n      radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.2) 0%, transparent 15%),\r\n      radial-gradient(circle at 40% 40%, rgba(255, 255, 255, 0.2) 0%, transparent 15%),\r\n      radial-gradient(circle at 60% 60%, rgba(255, 255, 255, 0.2) 0%, transparent 15%),\r\n      radial-gradient(circle at 30% 70%, rgba(255, 255, 255, 0.2) 0%, transparent 15%),\r\n      radial-gradient(circle at 70% 30%, rgba(255, 255, 255, 0.2) 0%, transparent 15%),\r\n      radial-gradient(circle at 10% 50%, rgba(255, 255, 255, 0.2) 0%, transparent 15%),\r\n      radial-gradient(circle at 90% 50%, rgba(255, 255, 255, 0.2) 0%, transparent 15%);\r\n    animation: float 15s ease-in-out infinite;\r\n    z-index: 1;\r\n    pointer-events: none;\r\n  }\r\n\r\n  @keyframes float {\r\n    0%, 100% { \r\n      transform: translateY(0) translateX(0);\r\n    }\r\n    25% { \r\n      transform: translateY(-10px) translateX(5px);\r\n    }\r\n    50% { \r\n      transform: translateY(0) translateX(10px);\r\n    }\r\n    75% { \r\n      transform: translateY(10px) translateX(5px);\r\n    }\r\n  }\r\n\r\n\r\n    /* Container principal avec glassmorphism */\r\n    ion-grid {\r\n        position: relative;\r\n        z-index: 1;\r\n        max-width: 400px;\r\n        margin: 0 auto;\r\n        padding: 2rem;\r\n        margin-top: 8rem;\r\n      }\r\n      \r\n      /* Carte glassmorphism pour le formulaire */\r\n      form {\r\n        background: rgba(255, 255, 255, 0.1);\r\n        backdrop-filter: blur(20px);\r\n        -webkit-backdrop-filter: blur(20px);\r\n        border: 1px solid rgba(255, 255, 255, 0.2);\r\n        border-radius: 16px;\r\n        padding: 2rem;\r\n        box-shadow: 0 8px 32px rgba(31, 38, 135, 0.37);\r\n        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n        position: relative;\r\n        overflow: hidden;\r\n      }\r\n      \r\n      form::before {\r\n        content: '';\r\n        position: absolute;\r\n        top: 0;\r\n        left: -100%;\r\n        width: 100%;\r\n        height: 100%;\r\n        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);\r\n        transition: left 0.5s;\r\n      }\r\n      \r\n      form:hover::before {\r\n        left: 100%;\r\n      }\r\n      \r\n      form:hover {\r\n        transform: translateY(-2px);\r\n        box-shadow: 0 12px 40px rgba(31, 38, 135, 0.5);\r\n      }\r\n      \r\n      /* Styling des champs de saisie */\r\n      ion-item {\r\n        --background: rgba(255, 255, 255, 0.9);\r\n        --border-radius: 12px;\r\n        --inner-padding-start: 16px;\r\n        --inner-padding-end: 16px;\r\n        --padding-start: 0;\r\n        --padding-end: 0;\r\n        margin-bottom: 1.5rem;\r\n        border-radius: 12px;\r\n        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\r\n        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n        border: 2px solid transparent;\r\n      }\r\n      \r\n      ion-item:hover {\r\n        transform: translateY(-1px);\r\n        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);\r\n      }\r\n      \r\n      ion-item.item-has-focus {\r\n        --background: rgba(255, 255, 255, 0.95);\r\n        border-color: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n        background-clip: padding-box;\r\n      }\r\n      \r\n      /* Labels flottants améliorés */\r\n      ion-label {\r\n        --color: #636e72;\r\n        font-weight: 500;\r\n        font-size: 0.9rem;\r\n        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n      }\r\n      \r\n      ion-item.item-has-focus ion-label {\r\n        --color: #667eea;\r\n        font-weight: 600;\r\n      }\r\n      \r\n      /* Champs de saisie */\r\n      ion-input {\r\n        --color: #2d3436;\r\n        --placeholder-color: #636e72;\r\n        font-size: 1rem;\r\n        font-weight: 500;\r\n      }\r\n      \r\n      /* Bouton de connexion moderne */\r\n      .btn {\r\n        width: 100%;\r\n        height: 3.5rem;\r\n        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n        color: white;\r\n        border: none;\r\n        border-radius: 12px;\r\n        font-size: 1.1rem;\r\n        font-weight: 600;\r\n        letter-spacing: 0.5px;\r\n        text-transform: none;\r\n        margin: 1.5rem auto 2rem;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        cursor: pointer;\r\n        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n        box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);\r\n        position: relative;\r\n        overflow: hidden;\r\n      }\r\n      \r\n      .btn::before {\r\n        content: '';\r\n        position: absolute;\r\n        top: 0;\r\n        left: -100%;\r\n        width: 100%;\r\n        height: 100%;\r\n        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\r\n        transition: left 0.5s;\r\n      }\r\n      \r\n      .btn:hover {\r\n        transform: translateY(-2px);\r\n        box-shadow: 0 8px 25px rgba(102, 126, 234, 0.6);\r\n      }\r\n      \r\n      .btn:hover::before {\r\n        left: 100%;\r\n      }\r\n      \r\n      .btn:active {\r\n        transform: translateY(0);\r\n      }\r\n\r\n      .buttons-container{\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        gap: 1rem;\r\n      }\r\n      \r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
